import React, { Component } from "react";
import Landing from "./LandingContainer";
import TableUpdateUsers from "./../components/TableUpdateUsersComponent";
import Paginator from "./../../Paginator/containers/PaginatorContainer";
import LoaderDots from "./../../Modal/components/LoaderDots";

import Search from "@material-ui/icons/Search";

import ModificateUserComponent from "./../components/ModificateUserComponent";
import "./../changePasswordContainer.css";
// import "./../modificateUserContainer.css";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../Actions/Dashboard";
import * as modalActs from "./../../Actions/Modal";
import * as sessionActs from "./../../Actions/Session";

import { sendService, answerOk, makeId } from "./../../Services/service";

import Form, { formTypes } from "../../Forms/Containers/FormCreator";
import Warning from "@material-ui/icons/Warning";
import ChangePass from './../components/ChangePassAdminComponent'

class ModificateUserContainer extends Component {
  state = {
    hasFooter: false,
    consultTable: true,
    loading: false,
    control: { count: 0, page: 0, pages: 0, pageSize: 20 },
    rows: [],
    page: 0,
    search: "",
    user: {},
    permitions: [],
    password: {
      newPassword: '',
      confirmNewPassword: ''
    }
  };

  handlerActiveUser = async item => {
    this.loader(true);
    var res = await sendService(
      "/api/v1/users/activate/" + item.id + "/" + !item.active,
      "PUT"
    );
    this.loader(false);
    if (!answerOk(res, this.props.sessionActions.closeSession)) return;
    this.getPageInfo();
  };

  handlerUpdateUser = async item => {
    this.loader(true);
    var res = await sendService("/api/v1/users/getUser/" + item.user, "GET");
    this.loader(false);
    if (!answerOk(res, this.props.sessionActions.closeSession)) return;
    console.log(res)
    this.setState({ user: res.response.users, permitions: res.response.permitions, consultTable: false });
  };

  getPageInfo = async (page = 0) => {
    this.loader(true);
    let url = "/api/v1/users/get/" + this.props.session.user.perfil + "?pageSize=20&page=" + page;
    var res = await sendService(
      this.state.search !== "" ? url + "&search=" + this.state.search : url,
      "GET"
    );
    this.loader(false);
    if (!answerOk(res, this.props.sessionActions.closeSession)) return;
    this.setState({ ...res.response.response });
  };

  loader = state => {
    // this.setState({loading:state})
  };

  handlerTextChange = ev => {
    this.setState({ search: ev.target.value });
  };

  handlerKeyUp = ev => {
    if (ev.keyCode === 13) this.clearAndSearch();
  };

  clearAndSearch = () => {
    this.setState({ page: 0 });
    this.getPageInfo();
  };

  componentDidMount = async () => {
    this.getPageInfo();
  };

  cancelUser = () => {
    this.setState({ consultTable: true });
  }

  onChangeRoute = route => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  };

  handlerPassword = (key, value, item) => {
    this.props.modalActions.closeModal()
    const password = {
      ...this.state.password,
      [key]: value
    }
    this.setState({ password })
    this.props.modalActions.openModal(
      <ChangePass
        onSubmit={() => this.handlerSubmitPassword(item)}
        onChange={(key, value) => this.handlerPassword(key, value, item)}
        onCancel={this.closeModal}
        autoGen={this.autoGenPassword}
        values={password}
      />
    )
  }

  handlerSubmitPassword = async (item) => {
    if (this.state.password.newPassword === this.state.password.confirmNewPassword) {
      let resp = await sendService('/api/v1/users/changePasswordAdmin/' + item.id, 'PUT', this.state.password)
      if (!answerOk(resp, this.props.sessionActions.closeSession)) return false;
      window.alert(resp.response.msg)
      this.closeModal()
      // return true
    }
  }

  autoGenPassword = (item) => {
    this.props.modalActions.closeModal()
    const pass = makeId(8)
    const password = {
      newPassword: pass,
      confirmNewPassword: pass
    }
    this.setState({ password })
    this.props.modalActions.openModal(
      <ChangePass
        onSubmit={() => this.handlerSubmitPassword(item)}
        onChange={(key, value) => this.handlerPassword(key, value, item)}
        onCancel={this.closeModal}
        autoGen={() => this.autoGenPassword(item)}
        values={password}
      />
    )
  }

  changePassword = (item) => {
    const password = {
      newPassword: '',
      confirmNewPassword: ''
    }
    this.setState({ password })
    this.props.modalActions.openModal(
      <ChangePass
        onSubmit={() => this.handlerSubmitPassword(item)}
        onChange={(key, value) => this.handlerPassword(key, value, item)}
        onCancel={this.closeModal}
        autoGen={() => this.autoGenPassword(item)}
        values={password}
      />
    )
  }


  modal = (text, status) => {
    return (
      <>
        <div>
          <div className="modal-icon">
            <div className="center">
              <Warning />
            </div>
            ADVERTENCIA
          </div>
          <div className="modal-message">{text}</div>
          <div className="container-content">
            <Form
              onChange={this.handlerChange}
              objectCreator={[
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                },
                {
                  type: formTypes.submit,
                  classContainer: "button-primary line line-20 text-center",
                  label: "Aceprtar",
                  placeholder: "-"
                },
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                }
              ]}
              onSubmit={this.closeModal}
            />
          </div>
        </div>
      </>
    );
  };

  closeModal = () => {
    this.props.modalActions.closeModal()
    this.setState({
      password: {
        newPassword: '',
        confirmNewPassword: ''
      }
    })
  }

  handlerUpdate = async form => {
    this.props.modalActions.openLoader();
    let url = "/api/v1/users/update/" + form.id;
    var res = await sendService(url, "PUT", form);
    this.props.modalActions.closeLoader();
    if (!answerOk(res, this.props.sessionActions.closeSession)) return;
    this.setState({ consultTable: true });
    this.getPageInfo(this.state.control.page);
  }

  handlerSubmit = async () => {
    let resp = await sendService('/api/v1/users/changePassword/' + this.props.session.user.id, 'PUT', this.state.form)
    if (!answerOk(resp, this.props.sessionActions.closeSession)) return false;
    this.props.modalActions.openModal(this.modal(resp.response))
    return true
  };


  render() {
    return (
      <Landing history={this.props.history} hasFooter={this.state.hasFooter}>
        {this.state.consultTable ? (
          <div className="background-body">
            <div className="talesino white-bg" style={{ width: '1160px', margin: 'auto' }}>
              <div
                className={
                  this.state.hasFooter
                    ? "container-content"
                    : "container-content-no-footer"
                }
              >
                <div className="search-container" >
                  <div>
                    <input
                      style={{ height: '50px', width: '135px', cursor:'pointer' }}
                      type="buton"
                      className="search-submit clickable"
                      value="Agregar usuario +"
                      onClick={() => this.onChangeRoute('/Crear-usuario')}
                    />
                  </div>
                  <div className="search-form" style={{ margin: '0' }}>
                    {this.state.loading && <LoaderDots />}
                    <div className="search-container-input">
                      <Search className="search-icon" />
                      <input
                        type="text"
                        className="search-input"
                        value={this.state.searchText}
                        onChange={this.handlerTextChange}
                        onKeyUp={this.handlerKeyUp}
                      ></input>
                    </div>
                    <input
                      type="submit"
                      className="search-submit clickable"
                      value="Buscar"
                      onClick={this.clearAndSearch}
                    />
                  </div>
                </div>
                <TableUpdateUsers
                  content={this.state.rows}
                  hasFooter={this.state.hasFooter}
                  update={this.handlerUpdateUser}
                  activate={this.handlerActiveUser}
                  changePassword={this.changePassword}
                />
                <div >
                  <Paginator
                    control={this.state.control}
                    onClick={this.handler}
                    setKey="user-update-table-key-"
                  />
                </div>
                <div></div>
              </div>
            </div>
          </div>
        ) : (
          <ModificateUserComponent
            user={this.state.user}
            permitions={this.state.permitions}
            onCancel={this.cancelUser}
            onSubmit={this.handlerUpdate}
          />
        )}
      </Landing>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    actions: bindActionCreators(actions, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch)
  };
}

function mapStateToProps(state, props) {
  return {
    session: state.session
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModificateUserContainer);
